import React from "react";
import { Icon } from "antd";
import styles from "./styles/PrintButton.scss";
import ReactGA from "react-ga4";
import useHrPageName from "../../utils/useHrPageName";

const onPrint = (hrPageName: string) => {
  ReactGA.event({
    category: "Detalji oglasa",
    action: "Click",
    label: `Isprintaj oglas - ${hrPageName}`
  });
  window.print();
};

function PrintButton({ category, categories }) {
  const hrPageName = useHrPageName(category);
  return (
    <span
      tabIndex={0}
      role="button"
      className={styles.printButton}
      title={"Isprintaj"}
      onClick={() => onPrint(category)}
    >
      <Icon type="printer" className={styles.icon} />
      {"Isprintaj"}
    </span>
  );
}

export default PrintButton;



// WEBPACK FOOTER //
// ./src/components/PrintButton/index.tsx